<!-- =========================================================================================
  File Name: AttendeeEdit.vue
  Description: Attendee Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-user-edit" class="attendee-form-wrap">
    <div class="header-custome">
      <h3>Edit Attendee</h3>
    </div>
    <vs-alert color="danger" title="Attendee Not Found" :active.sync="user_not_found">
      <span>Attendee record with id: {{ $route.params.AttendeeId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="user_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs position="left" v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab v-model="activeTab" class="tab-wrap" label="Account" icon-pack="feather" icon="icon-user">
               
            <div class="tab-text">
              <attendee-edit-tab-account :data="user_data" @activateTab="setActiveTab" />
            </div>
          </vs-tab>
          <vs-tab v-model="activeTab" label="Social" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <attendee-edit-tab-social :data="user_data" @activateTab="setActiveTab" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import AttendeeEditTabAccount from "./AttendeeEditTabAccount.vue";
import AttendeeEditTabSocial from "./AttendeeEditTabSocial.vue";

// Store Module
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";


export default {
  components: {
    AttendeeEditTabAccount,
    AttendeeEditTabSocial
  },
  data() {
    return {
      user_data: null,
      user_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    };
  },
  watch: {
    activeTab() {
      this.fetch_user_data(this.$route.params.AttendeeId);
    }
  },
  methods: {
    setActiveTab(val){
      this.activeTab = val;
    },
    fetch_user_data(AttendeeId) {
    //console.log(AttendeeId)
      this.$store
        .dispatch("attendeeManagement/fetchAttendee", AttendeeId)
        .then(res => {
          this.user_data = res.data;
        })
        .catch(err => {
          /*if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }*/
          console.error(err);
        });
    },
    
  },
  created() {
    //debugger;
    // Register Module UserManagement Module
      if (this.$route.params.AttendeeId == undefined) {
      this.$router.push({ name: "attendees" }).catch(() => {});
    } else {
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule("attendeeManagement", moduleAttendeeManagement);
      moduleAttendeeManagement.isRegistered = true;
    }
    this.fetch_user_data(this.$route.params.AttendeeId);
    }
  }
};
</script>